import CallTypes from 'store/call/call.types';
import GlobalTypes from 'store/global/global.types';
import { Middleware } from 'redux';
import AnyAction from '../anyActions';
import RootState from 'store/state';
import { NotificationControl } from 'utils';
import ChatTypes from 'store/chat/chat.types';

let audioEl: HTMLMediaElement;
let defaultAudioEl: HTMLMediaElement;
let chatNewMessageAudio: HTMLMediaElement | undefined = undefined;

export const audio: Middleware<{}, RootState> = store => next => (action: AnyAction) => {
    switch (action.type) {
        case CallTypes.CALLBACK_CALL:
        case CallTypes.INCOMING_CALL: {
            const { settings, app } = store.getState();
            const { customerEndpointAddress } = action.payload.contact;
            const ringingDevice = settings?.ringingDevice;
            //ring on 'secondary' device if user picked one in settings
            if (ringingDevice && ringingDevice.deviceId !== 'default') {
                audioEl =
                    ringingDevice &&
                    new Audio('https://prod-cdn-12059162352.s3.eu-west-2.amazonaws.com/audio/ring.wav');
                //@ts-ignore setSinkId() is experimental so not in TS definitions
                audioEl.setSinkId(ringingDevice.deviceId);
                audioEl.loop = true;
                audioEl.play();
            }

            if (app.callProvider === 'kumodi') {
                //For kumodi, the iframe itself doesn't 'ring ring' on the deafult device (connect does)
                //To keep behaviour consistent we need to 'ring ring' in our app on default device
                defaultAudioEl = new Audio('https://prod-cdn-12059162352.s3.eu-west-2.amazonaws.com/audio/ring.wav');
                defaultAudioEl.loop = true;
                defaultAudioEl.play();
            }

            return next(action);
        }
        case CallTypes.ACCEPT_CALL:
        case CallTypes.REJECT_CALL:
        case CallTypes.CALL_ENDED:
        case CallTypes.CONNECTION_CONNECTING:
        case CallTypes.CONNECTION_STARTED:
            audioEl && audioEl.pause();
            defaultAudioEl && defaultAudioEl.pause();
            return next(action);
        case ChatTypes.RECIEVE_CHAT_MESSAGE:
            next(action);
            if (
                ['CUSTOMER', 'SYSTEM'].includes(action.payload.msg.ParticipantRole!) &&
                action.payload.id !== store.getState().contact?.ID
            ) {
                if (!chatNewMessageAudio) {
                    chatNewMessageAudio = new Audio(
                        'https://prod-cdn-12059162352.s3.eu-west-2.amazonaws.com/audio/sa-chat-new-message.wav'
                    );
                }

                chatNewMessageAudio?.play();
            }
            return;

        default:
            return next(action);
    }
};

export default audio;
